import React from 'react'
import { Grid} from '@mui/material'
import { Link } from "react-router-dom";


import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Logo from '../images/logo.webp'



const drawerWidth = 240;
const navItems = ['Home', 'About', 'Contact'];
const menuItems = [{label:'Home', link:'/'}, {label:'About', link:'/about'}, {label:'Contact', link:'/contact'}]

function NavBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" 
      sx={{ my: 2, 
            }}>
        {/* YECO CANADA */}
        <img src={Logo} alt='logo' style={{width:"100px"}} />
      </Typography>
      <Divider />
      <List>
        {menuItems.map((item) => (
           
            <ListItem key={item.label} disablePadding>
              <ListItemButton sx={{ textAlign: 'center' }}>
               <Link to={item.link}> <ListItemText primary={item.label} /></Link>
              </ListItemButton>
            </ListItem>

            // <Grid container>
            //  <li style={{background:'red'}}>{item.label}</li>
            // </Grid>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;
  

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar component="nav" variant='outlined' elevation={0} style={{background:'#fff'}}>
        <Toolbar >
          <IconButton
            color="primary"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h7"
            component="div"
            color='primary'
            sx={{ 
              flexGrow: 1, 
              display: { xs: 'none', sm: 'block' },
              fontFamily:'epilogue',
              fontWeight:'700',
            }}
          >
            {/* YECO CANADA */}
            <img src={Logo} alt='logo' style={{width:"70px"}} />
            
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' },}}>
            {menuItems.map((item) => (
              <Link to={item.link} style={{textDecoration:"none"}}>
                <Button key={item.label} sx={{ color:'hsl(0, 0%, 41%)' }}>
                  {item.label}
                </Button>
              </Link>
            ))}
          </Box>
        </Toolbar>
      </AppBar>

      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      
      {/* <Box component="main" 
      sx={{ p:0,backgroundImage:`url(${Image1})`}}
      >
        <Toolbar />
        <Grid container >
          delectus quo eius exercitationem tempore. Delectus sapiente, provident
          corporis dolorum quibusdam aut beatae repellendus est labore quisquam
          praesentium repudiandae non vel laboriosam quo ab perferendis velit ipsa
          deleniti modi! Ipsam, illo quod. Nesciunt commodi nihil corrupti cum non
          fugiat praesentium doloremque architecto laborum aliquid. Quae, maxime
          recusandae?
          
        </Grid>
      </Box> */}
    </Box>
  );
}

export default NavBar;